import { useCurrentUser } from '@cosuno/authentication-frontend';
import { COLOR, Icon, Label } from '@cosuno/cosuno-ui';
import React, { memo } from 'react';

import useTranslation from '~/shared/hooks/useTranslation';

import { PromptBar, TextWrapper } from './Styles';

const OverdueInvoiceWarning: React.FC = () => {
  const { t } = useTranslation('overdueInvoiceWarning');
  const user = useCurrentUser();

  if (!user?.company.hasOverdueInvoice) {
    return null;
  }

  return (
    <PromptBar $color={COLOR.danger}>
      <TextWrapper>
        <Icon type="alert" color={COLOR.white} size={20} />
        <Label variant="large" color={COLOR.white}>
          {t('message')}
        </Label>
      </TextWrapper>
    </PromptBar>
  );
};

export default memo(OverdueInvoiceWarning);
